import script from "./SkillList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillList.vue?vue&type=script&setup=true&lang=js"

import "./SkillList.vue?vue&type=style&index=0&id=6e834ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e834ed0"]])

export default __exports__